import { DataFieldValueV2Extended } from "@iventis/datafields";

/** Removes the timezone from a date given a datafield value */
export function removeTimeZoneFromDate(dataFieldValue: DataFieldValueV2Extended): DataFieldValueV2Extended["valueDate"] {
    if (dataFieldValue.valueDate == null && typeof dataFieldValue.valueDate !== "string") {
        return null;
    }
    return (dataFieldValue.valueDate as string).replace("Z", "");
}
